import { XMLRootTag } from "./XMLRootTag";

function Viewmodel2XMLStr(val) {
  if (typeof val === "string") {
    val  = val.replaceAll('\\', '\\\\')
    val  = val.replaceAll("\n","\\n")
  }
  return val;
}

/**
 *
 * @param {XMLDocument} doc
 * @param {import("./ElementArray").default} elementArray
 */
 async function elementArrayToXML(doc, parentElement, elementArray) {
  const elemMeta = elementArray.metadata;
  if (elementArray.hasChanged.value || (elemMeta.tagValueByName("ForceRewrite") === "onWriteParent")) {
    if (elemMeta.isLookup())
      return;

    let writeAction = elemMeta.tagByName("WriteAction")
    let insertParent = parentElement;
    if (writeAction && writeAction.value() === "Root") {
      insertParent = doc.firstElementChild;
    }

    await Promise.all(elementArray.dataElements.
      map(async dataElement => {
        const element = await dataElement2XMLElement(doc, dataElement);
        if (element) {
          insertParent.appendChild(element);
          await Promise.all(dataElement.subElements.keys.map(async key => {
            await elementArrayToXML(doc, element, dataElement.subElements[key]);
          }));
      }
    }));

  }
}

async function dataElement2XMLElement(doc, dataElement) {
  let xmlelement = null;
  const elemMeta = dataElement.metadata;
  const isThisForceRewrite = elemMeta.tagValueByName("ForceRewrite") === "onWriteParent";
  // shallCreateXML ist Standard um zu entscheiden "Soll geschrieben werden?"
  let shallCreateXML = dataElement.hasChanged.value ||
                       isThisForceRewrite;
  // beforeWriteHandler
  // a) Vor dem rausschreiben noch eine Änderung an dem Datensatz vornehmen
  // b) Soll dieser Datensatz vlt. gar nicht geschrieben werden. Dann wird false geliefert
  shallCreateXML = shallCreateXML && 
                   (dataElement.root().beforeWriteHandler.get(elemMeta)?.(dataElement) !== false); // Hier ausdrücklich nicht auf falsy testen sondern auf false!!

  if (shallCreateXML) {  
    const writeClass = elemMeta.writeClass();
    xmlelement = doc.createElement(writeClass);
    let innerWriteClasses = {};

    let attributes = [];
    if (dataElement.isNew.value) {
      if (elemMeta.tagValueByName("canInsert") === "onInsertOnlyAttributes") {
        attributes = elemMeta.allAttributes.filter(a => a.tagValueByName("Visible") === "onInsert");
      }
      else {
        attributes = elemMeta.allAttributes.filter(a => a.tagByName("WizardField") || a.tagByName("InsertField"));
      }
    }
    if (attributes.length === 0) {
      attributes = elemMeta.allAttributes.filter(a => { return a.doWriteOut(dataElement); });
    }
    await Promise.all(
      attributes.map(async (attribute) => {
          let value = dataElement.$$[attribute.name()].stringValue.value;
          value = Viewmodel2XMLStr(value);
          const attribWriteName = attribute.writeName();
          const innerWriteClass = attribute.tagByName("InnerWriteClass")?.value();
          if (attribWriteName) {
            if (innerWriteClass) {
              if (!innerWriteClasses[innerWriteClass]) {
                innerWriteClasses[innerWriteClass] = document.createElement(innerWriteClass);
                innerWriteClasses[innerWriteClass].setAttribute("_action", "write");
              }
              innerWriteClasses[innerWriteClass].setAttribute(attribWriteName, value);
            }
            else {
              xmlelement.setAttribute(attribWriteName, value);
            }
          }
        })
    );
    if (elemMeta.fkName() && elemMeta.tagValueByName("WriteAction") !== "Root") {
      xmlelement.setAttribute("_foreignkey", elemMeta.fkName())
    }
    // Wenn die persistenceCondition false ist, bedeutet dies, dass der Datensatz nicht existieren sollte
    if (dataElement.isDeleted.value || dataElement.persistenceCondition.value===false) {
      xmlelement.setAttribute("_action", "delete");
    }
    else if (dataElement.selfHasChanged.value || isThisForceRewrite) {
      xmlelement.setAttribute("_action", "write");
      for (let key in innerWriteClasses) {
        xmlelement.appendChild(innerWriteClasses[key]);
      }
    }   
  }
  return xmlelement;
}

export async function dataElement2XML(dataElement) {
  let doc = document.implementation.createDocument("", "", null);
  let root = doc.createElement(XMLRootTag)
  doc.appendChild(root);
  const element = await dataElement2XMLElement(doc, dataElement);
  if (element) {
    root.appendChild(element)
    await Promise.all(dataElement.subElements.keys.map(async key => {
      await elementArrayToXML(doc, element, dataElement.subElements[key]);
    }));
  }
  return doc;
  
}

/**
 * @param {import("./RootElement").default} aVM
 * @returns {Promise<XMLDocument>}
 */
export async function viewModel2XML(aVM) {
  let doc = document.implementation.createDocument("", "", null);
  let root = doc.createElement(XMLRootTag)
  doc.appendChild(root);
  for(let key of aVM.subElements.keys){
    await elementArrayToXML(doc, root, aVM.subElements[key]);
  }
  return doc;
}